export default {"src":"/_next/static/media/ic-filedownload.c950b4bd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};